import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import AssetStorefrontContainer from '../../storefront/containers/AssetStorefrontContainer';
import NotFoundError from '../../components/error/NotFoundError';
import { useFetchThemeCollectionOfferingIds } from '../hooks/useFetchThemeCollectionOfferingIds';
import { getIsInApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeCollectionContainer() {
  const {
    collection: slug
  } = useParams();
  const isInApp = useSelector(getIsInApp);
  const {
    getCollectionBySlug,
    requestState: collectionsRequestState
  } = useCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const collection = getCollectionBySlug(slug);
  const {
    fetchThemeCollectionOfferingIds
  } = useFetchThemeCollectionOfferingIds({
    collectionId: collection ? collection.id : undefined
  });
  const handleFetchCollectionOfferingIds = useCallback(() => fetchThemeCollectionOfferingIds(), [fetchThemeCollectionOfferingIds]);
  if (!isFulfilled(collectionsRequestState)) {
    return null;
  }
  if (!(collection && collection.publishedListing)) {
    return /*#__PURE__*/_jsx(NotFoundError, {});
  }
  return /*#__PURE__*/_jsx(AssetStorefrontContainer, {
    collectionId: collection.id,
    title: collection.publishedListing.title,
    description: /*#__PURE__*/_jsx(SanitizedText, {
      body: collection.publishedListing.description,
      WrapperComponent: "span"
    }),
    onFetchCollectionOfferingIds: handleFetchCollectionOfferingIds
  });
}